import { Injectable } from '@angular/core';
import { from } from 'rxjs';
import { getUserSession,setUserSession } from 'src/app/utils/util';
import{LoginService} from '../services/login.service';


export interface ISignInCredentials {
  email: string;
  password: string;
}

export interface ICreateCredentials {
  email: string;
  password: string;
  displayName: string;
}

export interface IPasswordReset {
  code: string;
  newPassword: string;
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(private loginService:LoginService) {
  }

  signIn(credentials: ISignInCredentials) 
  {
   return this.loginService.loginIn(credentials.email, credentials.password)
   .then(user  => {
    setUserSession(user);
     return user;
   });
  }

  signOut() {
    return this.loginService.logOut()
    .then(()  => {
      return "success";
    });
  }

  async getUser() {
    const user=getUserSession();
    return user;
  }

  sendPasswordEmail(email: string) {
    return this.loginService.sendPasswordEmail(email).then((data) => {
      return data;
    });
  }
}
